// 問い合わせ導線の固定 URL を一元管理する
export const WHATSAPP_CONSULTATION_URL = 'https://api.whatsapp.com/message/6JSOXXII6OJKM1?autoload=1&app_absent=0'
